module.exports = __webpack_public_path__ + "static/media/delete.665926e2.svg";